export default class FormValidationErrors {
    constructor(form) {
        this.form = form;
    }
    show(data) {
        var $this = this;
        var data = data.response.data;
        if (TokenMismatch.check(data)) {
            return;
        }
        if (data.message) {
            if (data.message == "The given data was invalid.") {
                new Flash.error("You have errors in your form.");
            } else {
                new Flash.error(data.message);
            }
        }
        $.each(data.errors, function(key, value) {
            var errors = $this.combineErrors(value);
            $this.showInputErrors(key, errors);
            $this.showSelectErrors(key, errors);
        });
    }
    combineErrors(value) {
        if (Array.isArray(value)) {
            value = value.join(" <br> ");
        }
        return value;
    }
    showInputErrors(key, value) {
        var input = this.form.find("input[name=" + key + "]");
        if (!input.length) {
            var input = this.form.find("input[name^=" + key + "]");
        }
        if (input.length) {
            if (
                input.attr("type") == "checkbox" ||
                input.attr("type") == "radio"
            ) {
                this.checkBox(key, input, value);
            } else {
                input
                    .addClass("is-invalid")
                    .after('<div class="invalid-feedback">' + value + "</div>");
            }
        }
        this.form
            .find("textarea[name=" + key + "]")
            .addClass("is-invalid")
            .after('<div class="invalid-feedback">' + value + "</div>");
    }
    checkBox(key, input, value) {
        var errorContainer = "#" + key + "-errors";
        $(errorContainer).html(
            '<p class="invalid-feedback d-block">' + value + "</p>"
        );
    }
    showSelectErrors(key, value) {
        var select = this.form.find("select[name=" + key + "]");
        if (!select.length) {
            var select = this.form.find("select[name^=" + key + "]");
        }
        if (select.hasClass("select2-hidden-accessible")) {
            // Because we are using select2 we have to account for the markup that select2 outputs. Hence the .next()
            select
                .next()
                .addClass("is-invalid")
                .after(
                    '<div class="invalid-feedback d-block">' + value + "</div>"
                );
        } else {
            // Incase the select is a normal select
            select
                .addClass("is-invalid")
                .after('<div class="invalid-feedback">' + value + "</div>");
        }
    }
}
